import React from "react";
import AnimationRevealPage from "helpers/AnimationRevealPage.js";
import Hero from "components/hero/OneColumnCentered.js";
import Actions from "components/features/ThreeColumnActions";
import UniformShopCard from "components/cards/UniformShopCard.js";
import SupportCard from "components/cards/SupportCard.js";
/*
import MainFeature from "components/features/TwoColSingleFeatureWithStats.js";
import Blog from "components/blogs/PopularAndRecentBlogPosts.js";
import Testimonial from "components/testimonials/TwoColumnWithImageAndProfilePictureReview.js";
import FAQ from "components/faqs/SimpleWithSideImage.js";
import SubscribeNewsLetterForm from "components/forms/SimpleSubscribeNewsletter.js";
*/
import Footer from "components/footers/CCSFooter.js";

export default () => (
  <AnimationRevealPage>
    <Hero />
    <Actions />
    <SupportCard />
    <UniformShopCard />
    <Footer />
  </AnimationRevealPage>
);

/*
    <MainFeature />
    <Blog />
    <Testimonial textOnLeft={true}/>
    <FAQ />
    <SubscribeNewsLetterForm />
*/